var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-logo"},[_c('div',{staticClass:"custom-logo",style:({backgroundImage: ("url(" + _vm.publicPath + "custom-logo.png)")})}),_c('span',{staticClass:"the-logo__title"},[_vm._v(_vm._s(_vm.$t('common.profetAI')))])])}
var staticRenderFns = []

export { render, staticRenderFns }